module.exports = __webpack_public_path__ + "img/bbc_radio_wales.6ec31d2a.png";